import React, {Component, useCallback, useEffect} from 'react';
import {Button, Card, CardBody, Col, Container, Row} from 'reactstrap';
import PageMeta from 'components/PageMeta';
import Video from 'components/Video';
import Footer from 'components/Footer';
import logoTrees from 'static/logo/logo-trees-for-future-white.png';
import Section from 'components/Elements/Section';
import useBeacon from 'utils/useBeacon';
import CheckoutSelection, {CheckoutFinalSelection, FreeSelection} from 'components/Thc/CheckoutSelection';
import ThcOptions from 'components/Thc/CheckoutSelection';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import CheckoutButton from 'components/CheckoutButton';
import {faCartPlus, faLock} from '@fortawesome/pro-light-svg-icons';
import {Link} from 'react-scroll';

export default function () {
  useBeacon();
  return (
    <div className="page page-nosocial">
      <PageMeta title="THC Upsell" description="THC upsell page" />

      <div className="page-content">
        <Section id="thc-header" innerClass="text-white text-center pt-4" color="black">
          <Container>
            <Row>
              <Col>
                <p>
                  <strong>Thank you for taking a stand to be part of the SOLUTION! You’ve made a great choice.</strong>
                </p>
                <p>
                  And, as promised, you can{' '}
                  <span className="background-green px-1 rounded">
                    select your totally free bonus <br className="d-none d-sm-block d-lg-none" />
                    at the bottom of this page
                  </span>{' '}
                  — any one <br className="d-none d-lg-block" />
                  of the four health collections that make up Food Revolution Network’s Total Health Collection.
                </p>
                <p>
                  <strong>Or, you can get the entire Total Health Collection for just $47.</strong>
                </p>
                <p className="mt-4">Watch this video to learn more:</p>
              </Col>
            </Row>

            <Row className="d-flex justify-content-center">
              <Col lg="10" className="video-col px-0 px-sm-3">
                <Video url="https://www.youtube.com/watch?v=rEogZZyj3vE" playing />
              </Col>
            </Row>

            <Row className="mt-4">
              <Col>
                <p>
                  <strong>
                    <em>
                      Take a moment to read the following as this special opportunity{' '}
                      <br className="d-none d-md-block" />
                      WON’T be available again after you close this page.
                    </em>
                  </strong>
                </p>
              </Col>
            </Row>
          </Container>
        </Section>

        <Section id="thc-" color="white">
          <Container>
            <Row className="text-center">
              <Col>
                <p>
                  Each of the unique health collections within the Total Health Collection contains a specially curated
                  bundle of some of the most popular and life-changing health content we created in our first 10 years,
                  including summit interviews, Q&A-based action hours with world-leading experts, informative
                  guidebooks, personal workbooks, and amazingly delicious and nutritious recipes that will add vitality
                  and yumminess to your life.
                </p>
                <p>
                  Each one is well worth the $97 regular price — and an incredible value when you get yours absolutely
                  free.
                </p>
                <p className="mb-0">
                  <strong>But, if you want maximum results, then…</strong>
                </p>
              </Col>
            </Row>
          </Container>
        </Section>

        <Section id="thc-info" color="light-gray">
          <Container>
            <Row>
              <Col>
                <h3 className="section-heading text-center">
                  Take Your Health to the Next Level With the <br className="d-none d-lg-block" />
                  TOTAL Health Collection
                </h3>
                <div className="thc-product-image text-center mb-4">
                  <img
                    className="thc-selection-card-image"
                    src="https://cdn.foodrevolution.org/thc/thc-product-image.png"
                  />
                </div>
                <p className="text-center text-strikethrough">Regular Price: $297</p>
                <p>
                  With the Total Health Collection, you can have confidence in your future health. You’ll have the
                  insights to provide yourself and your loved ones with the nourishment that supports a healthy brain, a
                  healthy heart, a healthy immune system, and cancer prevention. It includes 12 of our most popular
                  health-focussed Summit interviews, 4 members-only WHOLE Life Action Hours, 4 guidebooks, and 24 of our
                  most beloved recipes.
                </p>
                <h4 className="my-4">Here’s what you’ll get:</h4>
                <ThcOptions />
              </Col>
            </Row>
          </Container>
        </Section>

        <Section id="thc-cta" color="gradient-indigo-purple-right">
          <Container>
            <Row>
              <Col>
                <h3 className="section-heading text-center text-white">This Page Only!</h3>
                <div className="cta-sales cta-sales-thc">
                  <div className="offer-box background-white border-dashed border-green border-2 offer-box-shadow px-3 py-4 px-sm-4 px-md-5 py-md-5">
                    <Row className="d-flex justify-content-center mb-4">
                      <Col lg="10">
                        <h4 className="section-heading text-center">
                          Get the Total Health Collection, <br className="d-none d-sm-block d-lg-none" />
                          Today Only $47
                        </h4>
                        <div className="thc-product-image text-center mb-4">
                          <img
                            className="thc-selection-card-image"
                            src="https://cdn.foodrevolution.org/thc/thc-product-image.png"
                          />
                        </div>
                        <p>
                          To separately get all four of the components in the Total Health Collection, you’d pay $388.
                          But, on this page only, as our thank you to you for your decision to get the Impact Kit, we’re
                          offering the Total Health Collection to you for <strong>only $47.</strong>
                        </p>
                        <p>
                          <strong>That’s an 88% discount!</strong>
                        </p>
                        <p className="mb-0">
                          <em>But, you have to act fast because this page is the only time you’ll get this chance.</em>{' '}
                          Click the button below to add the Total Health Collection to your order right now.
                        </p>
                      </Col>
                    </Row>
                    <div className="upsell-box-confirm text-center mb-3">
                      <div className="mb-3">
                        <CheckoutButton
                          className="offer-box-button offer-box-button-upsell"
                          sku="frs"
                          price="47"
                          slug="frs21-thc"
                        >
                          <FontAwesomeIcon className="mr-2" icon={faCartPlus} /> Yes, Add to Order
                        </CheckoutButton>
                      </div>
                      <div className="upsell-box-text">
                        Clicking “ADD TO ORDER” will add the Total Health Collection{' '}
                        <br className="d-none d-xl-block" />
                        to your purchase right now, for an additional one-time $47.
                      </div>
                    </div>

                    <div className="upsell-box-no text-center">
                      <Link
                        className="btn btn-link text-underline"
                        activeClass="active"
                        spy={true}
                        offset={0}
                        to="thc-offer"
                        smooth={true}
                        href="#"
                      >
                        Or, select your free bonus below.
                      </Link>
                    </div>

                    <div className="offer-box-details text-center">
                      <div className="offer-box-cards">
                        <img
                          className="img-fluid img-cc"
                          src="https://cdn.foodrevolution.org/global/images/payments-accepted-20240424.svg"
                          width={1800}
                          height={175}
                        />
                      </div>
                      <div className="offer-box-security mb-1">
                        <FontAwesomeIcon className="offer-box-security-icon mr-2" icon={faLock} />
                        For your security, all orders are processed on a secured server.
                      </div>
                      <div className="offer-box-protected d-flex justify-content-center">
                        Your purchase is protected by our 60-day money back guarantee.
                      </div>
                    </div>
                  </div>

                  <Row className="trees-for-future text-white d-flex align-items-center justify-content-center mt-5">
                    <Col xs="11" lg="8" className="mb-4 mb-lg-0">
                      <h6 className="section-only-heading text-center text-lg-left text-400">
                        For every new order, we make a donation to Trees for the Future, enabling them to plant another
                        organic fruit or nut tree in a low-income community.
                      </h6>
                    </Col>
                    <Col xs="11" lg="3" className="text-center">
                      <img className="logo-trees" src={logoTrees} />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </Section>

        <Section id="thc-offer" className="section-angle-last" color="light-gray" angle="none">
          <Container>
            <Row>
              <Col>
                <h5 className="section-heading">Don’t want the Total Health Collection?</h5>
                <p>
                  <strong>Select your free gift below.</strong>
                </p>
                <p className="mb-4">
                  Remember, if you don’t{' '}
                  <Link
                    className="text-underline"
                    activeClass="active"
                    spy={true}
                    offset={0}
                    to="thc-cta"
                    smooth={true}
                    href="#"
                  >
                    get the Total Health Collection today
                  </Link>
                  , you’ll be passing up on the option to get it for the lowest price we’ll ever offer it for (just
                  $47). But you can still add any ONE of the Health Collections to your Empowerment Package order, for
                  free.
                </p>
                <FreeSelection />
              </Col>
            </Row>
          </Container>
        </Section>
      </div>

      <Footer />
    </div>
  );
}
